import useMetabase from '@/hooks/use-metabase';
import { StaticDashboard } from '@/components/metabase/StaticDashboard';
import { FC } from 'react';

interface Props {
  userEmail: string;
}

export const UserInsights: FC<Props> = ({ userEmail }) => {
  const { dashboards } = useMetabase();
  const dashboardId = dashboards.userGroupLg.id;
  return (
    <StaticDashboard
      dashboardId={dashboardId}
      initialParameters={{ email: userEmail }}
      hiddenParameters={['email', 'group']}
      isDrawer
    />
  );
};

export default UserInsights;
